import { useEffect } from "react";
import { db } from "../../firebase/config";
import { setSponsorError } from "../../store/sponsor/actions/setError";
import { TalesSponsor } from "../types/TalesSponsor";
import { setSponsorData } from "../../store/sponsor/actions/setData";
import { useDispatch, useSelector } from "react-redux";
import { usedHooks } from "../../store/site/selectors";
import { addUsedHook } from "../../store/site/actions/addUsedHook";

export default function useSponsors() {
  const dispatch = useDispatch();
  const hooks = useSelector(usedHooks);

  useEffect(() => {
    if (!hooks.includes("useSponsors")) {
      dispatch(addUsedHook("useSponsors"));
      db.collection("sponsor")
        .orderBy("creationDate")
        .onSnapshot((snapshot) => {
          if (snapshot.empty) {
            dispatch(setSponsorError("Non è stato trovato nessuno sponsor"));
          } else {
            let sponsors: TalesSponsor[] = [];
            snapshot.docs.forEach((doc) => {
              sponsors = [...sponsors, doc.data() as TalesSponsor];
            });
            dispatch(setSponsorData(sponsors));
          }
        });
    }
  }, [dispatch, hooks]);
}
